import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LocalDatePipe } from "./local-date";
import { LocalNumberPipe } from "./local-number";
import { LocalNumberThousandFormatPipe } from "./local-number-thousand-format.pipe";
import { CustomTranslatePipe } from './custom-translate.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [LocalDatePipe, LocalNumberPipe, LocalNumberThousandFormatPipe, CustomTranslatePipe],
  exports: [LocalDatePipe, LocalNumberPipe, LocalNumberThousandFormatPipe,CustomTranslatePipe],
})
export class CustomPipesModule {}
